import React, { Children } from "react";
import { Form, InputNumber, message, Popover, Row, theme } from "antd";
import { URL_POND, URL_SKIM, URL_TANK, URL_TRUCK } from "../../constants/urls";
import { POST } from "../../frameworks/HttpClient";
import ColorButton from "../../common/ColorButton";

export default function LotSkimWeightPopover(props){
  const { target, onUpdate, children, title} = props;
  const [form] = Form.useForm(); 
  const [visible, setVisible] = React.useState(false);
  const inputRef = React.useRef(null);

  // ฟังก์ชันเปิด/ปิด Popover
  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
    form.resetFields();
  };


  const handleOK = async() => {
    try {
      const data = await form.validateFields();
      data["transaction"] = target;
      await POST(URL_SKIM.SKIM_TRANSACTION_WEIGHT_LOG, data);
      onUpdate();
      setVisible(false); 
    } catch (error) {
      if(error){
        console.log(error)
      }
    }
  }

  const handlePressEnter = () => {
    // โฟกัสไปยัง Input ตัวที่ 2
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const { token : { colorWarning }} = theme.useToken();

  React.useEffect(() => {
      form.resetFields();
  },[target])

  return (
    <Popover 
      title={<center>{title}</center>}
      trigger="click"
      open={visible}
      onOpenChange={handleVisibleChange}
      style={{ padding : 5}}
      content={ 
        <Form
          form={form}
          style={{ width: "100%"}}
          autoComplete="off">
            <Row>
            <Form.Item
              name={"weight"}
              style={{ alignItems: 'center',  justifyContent: 'center', display: 'flex', marginBottom : 5 }}
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}>
                  <InputNumber autoComplete="off" style={{ width: 250 }} placeholder="น้ำหนัก" addonBefore="น้ำหนัก" addonAfter="Kg" onPressEnter={() => handleOK()}/>
            </Form.Item>
            </Row>
            <Form.Item>
              <ColorButton type={"primary"} override={colorWarning} onClick={handleOK} style={{ float : 'right'}}>ยืนยัน</ColorButton>
              <ColorButton onClick={() => setVisible(false)} style={{ float : 'right', marginRight : 5 }}>ปิด</ColorButton>
            </Form.Item>
        </Form>
      }
    >
      {children}
    </Popover>
  )
}